import { inject, Injectable } from '@angular/core'
import { createEffect } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { filter, tap } from 'rxjs/operators'

import * as fromAccount from '.'
import { Account } from '../models'

@Injectable()
export class AccountEffects {
  private readonly store = inject(Store)
  private readonly account = inject(Account)

  pass$ = createEffect(
    () =>
      this.store.select(fromAccount.Selectors.feature).pipe(
        filter(acc => !!acc),
        tap(account => {
          Object.assign(this.account, account)
        }),
      ),
    { dispatch: false },
  )
}
